import { render, staticRenderFns } from "./albumDetail.vue?vue&type=template&id=dd855efc"
import script from "./albumDetail.vue?vue&type=script&lang=js"
export * from "./albumDetail.vue?vue&type=script&lang=js"
import style0 from "./albumDetail.vue?vue&type=style&index=0&id=dd855efc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports